import { fmtDate } from "../../extensions/utils";
import { Card, Spin, Typography } from "antd";

const { Text } = Typography;

const ClientItemVisit = ({ item, onClick, expanded, onExpand, sales, loading }) => {
  return<div className="client-item-sale" onClick={onClick || onExpand}>
    <div className="client-item-body">
      <div className="client-item-line-bold-double">
        <div className="client-item-clip">{item.productName}</div>
        <div className="client-item-clip-right">{fmtDate(item.docDate)}</div>
      </div>
      <div className="client-item-line-double-floated">
        <div className="client-item-clip">Визит #{item.id}</div>
        <div className="client-item-clip">Абонемент #{item.saleId}</div>
      </div>
      <div className="client-item-abon-expand" style={{ maxHeight: expanded ? 1200 : 0, opacity: expanded ? 1 : 0 }}>
        {expanded && (
          <div onClick={(e) => e.stopPropagation()} style={{ marginTop: "8px" }}>
            {loading ? (
              <Spin size="small" />
            ) : !sales.length ? (
              <Text type="secondary">Нет продаж по визиту</Text>
            ) : (
              sales.map((sale) => {
                const hasDebt = Number(sale.debet) > 0;
                return (
                  <Card key={sale.id} className="client-item-abon-card" style={{ marginBottom: 6, borderLeft: `4px solid ${hasDebt ? "#ff4d4f" : "#d9d9d9"}` }}>
                    <div className="client-item-abon-card-name-debt-fields">
                      <Text strong className="client-item-clip">{sale.productName}</Text>
                      <Text strong className="client-item-clip-right" style={{ color: hasDebt ? "#ff4d4f" : undefined }}>
                        К оплате: {sale.debet}
                      </Text>
                    </div>
                    <div className="client-item-abon-card-sum-sale-num-fields">
                      <Text className="client-item-clip">Цена: {sale.price}</Text>
                      <Text className="client-item-clip">Кол-во: {sale.qty}</Text>
                      <Text className="client-item-clip">Сумма: {sale.syma}</Text>
                    </div>
                  </Card>
                );
              })
            )}
          </div>
        )}
      </div>
    </div>
  </div>
}

export default ClientItemVisit;